import * as React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import themeDark from "../shared/themeDark";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import { MuiThemeProvider } from "@material-ui/core/styles";
import TransferWidget from "../shared/transferWidget";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import { Button, LinearProgress } from "@material-ui/core";
import api from "../../store/api";
import { useParams, useHistory } from "react-router-dom";
import TransferDetailsComponent from "../transferDetails/TransferDetailsComponent";
import { ISchedule } from "../../common/types";
import YellowBox from "./transferTrip/YellowBox";
import ChooseReason from "./transferTrip/ChooseReason";
import WaitingTimeModal from "./WaitingTimeModal/WaitingTimeModal";
import RetreatPopup from "./transferTrip/RetreatPopup";
import Popup from "./transferTrip/Popup";
import useWindowSize from "../shared/useWindowSize";
import TransferWidgetForTablets from "./transferTrip/TransferWidgetForTablets";
import { consts } from "../../common/consts";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  typoBold: {
    fontSize: 24,
    fontWeight: 900,
    color: "#FFF",
  },
  typoBoldSmall: {
    fontSize: 19,
    fontWeight: "bold",
    color: "#F4B827",
  },
  typoLight: {
    fontSize: 24,
    fontWeight: 400,
    color: "#FFF",
  },
  container: {
    width: "97%",
    margin: "auto",
  },
  loadingState: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#00152E",
  },
  loading: {
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  buttonRoot: {
    backgroundColor: "#F4B827",
    color: "#03090E",
    "&:hover": {
      backgroundColor: "#F4B827",
    },
    fontWeight: "bold",
  },
}));

const secondsFormat = (seconds: number) => {
  if (seconds < 3600) {
    let timeString = `${("0" + Math.floor(seconds / 60).toString()).slice(-2)}:${("0" + Math.floor(seconds % 60).toString()).slice(-2)}`;
    return timeString;
  } else {
    const minutes = (seconds % 3600) / 60;
    return `${("0" + Math.round(seconds / 3600).toString()).slice(-2)}:${("0" + Math.floor(minutes).toString()).slice(-2)}:${(
      "0" + Math.floor(seconds % 60).toString()
    ).slice(-2)}`;
  }
};

const Transition = React.forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement }, ref: React.Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TransferTrip(props: any) {
  const classes = useStyles();
  const [infoDialogOpen, setInfoDialogOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [showWaitingTimeModal, setShowWaitingTimeModal] = React.useState(false);
  const [waitingTimeModalTransferId, setWaitingTimeModalTransferId] = React.useState<string>();
  const [steps, setSteps] = React.useState(Array(1).fill(0));
  const [transfers, setTransfers] = React.useState<any>([]);
  const [currentTransfer, setCurrentTransfer] = React.useState(0);
  const currentTransferID = React.useRef(null);
  const [tripStatus, setTripStatus] = React.useState(1);
  const [timer, setTimer] = React.useState(0);
  const startTimerValue = React.useRef(0);
  const popState = React.useState(false);
  const [page, setPage] = React.useState(0);
  const history = useHistory();
  const { tripid } = useParams<{ tripid: string }>();
  const retreatPopup = React.useState(false);
  const { windowWidth } = useWindowSize();
  const [WaitTimeTransferStatus, setWaitTimeTransferStatus] = React.useState(0);
  const isFullTableWidth = windowWidth > 1280;
  const [loading, setLoading] = React.useState(false);
  const [buttonDisable, setButtonDisable] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const { authStore } = useSelector((state: RootState) => state);
  const [transferLoadingData, setTransferLoadingData] = React.useState<any>(transfers[currentTransfer]);
  const [enableRecordPCR, setEnableRecordPCR]=React.useState<boolean>(false);
  const [trigger, setTrigger]=React.useState<boolean>(false);
  const [WaitTimeClick, setWaitTimeClick]=React.useState<boolean>(false);

  interface IState {
    TransferStatus: number | null;
    AssignedVehicle: string | null;
  }

  const [states, setStates] = React.useState<IState>({
    TransferStatus: null,
    AssignedVehicle: null,
  });

  const CreateLoadingLine = (props: any): JSX.Element => {
    return (
        <div className={classes.loading}>
            <LinearProgress color="primary" />
        </div>
    )
  }

  const updateStep = (step: number, index: number) => {
    const updatedSteps = steps.map((item, i) => (i == index ? item + step : item));
    const updatedStep = steps[index] + step + (steps[index] + step == 4 ? 0 : 6);
    if (transfers[index]?.transferId) {
      if (updatedStep == 4) {
        currentTransferID.current = transfers[index]?.transferId;
        setPage(1);
        setSteps(updatedSteps);
      } else {
        updateTransferStatus(transfers[index]?.transferId, updatedStep == 6 ? 3 : updatedStep).then(() => {
          setSteps(updatedSteps);
        });
      }
      if (updatedSteps.every((item: number) => item == 4)) {
        setTripStatus(4);
      } else if (tripStatus == 4) {
        setTripStatus(3);
      }
    }
  };

  const closeInfoDialog = () => {
    setInfoDialogOpen(false);
    setCurrentTransfer(0);
    setTrigger((prevState) => !prevState);
  };

  const getTripDetails = async () => {
    setIsLoading(true);
    await api
      .getTrip(`tripId=${tripid}`)
      .then((res) => {
        setTransfers(res?.model || []);
        setSteps(res?.model.map((item: any) => (item.status == 4 ? 4 : item.status == 3 ? -1 : item.status - 6)));
      })
      .catch(() => {
        setIsLoading(false);
        history.replace("/transferSchedule");
      });
    await api
      .getTripGetails(`tripId=${tripid}`)
      .then((res) => {
        if (res?.model?.startedDateTime) {
          startTimerValue.current = new Date(`${res.model.startedDateTime}Z`).getTime();
          setTripStatus(res?.model?.status || 2);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
    setIsLoading(false);
  };

  React.useEffect(() => {
    getTripDetails();
    const showModel = localStorage.getItem('ShowWaitModel');
    setShowWaitingTimeModal(Boolean(showModel))
  }, []);

  React.useEffect(() => {
    if(transfers.length > 0){
      setStates((prevState) => ({
        ...prevState,
        TransferStatus: transfers[currentTransfer].status,
        AssignedVehicle: transfers[currentTransfer].assignedVehicle,
      }));
      setTransferLoadingData(transfers[currentTransfer]);
    }
  }, [currentTransfer, trigger]);

  React.useEffect(() => {
    if(authStore?.data?.role
                    ?.split(",")
                    ?.some((p) => p === consts.Permissions.SubmitPatientCareRecord
                    || p === consts.Permissions.SMASubmitPatientCareRecords)  
                           && (states.TransferStatus === consts.TransferStatus.InProgress ||
                               states.TransferStatus === consts.TransferStatus.EnRouteToDestination ||
                               states.TransferStatus === consts.TransferStatus.DroppingOff ||
                               states.TransferStatus === consts.TransferStatus.PickingUp))
                               {
                                setEnableRecordPCR(true);
                               }
                               else{
                                setEnableRecordPCR(false);
                               }
  }, [states]);

  React.useEffect(() => {
    if (tripStatus == 2 || tripStatus == 3 || tripStatus == 4) {
      setSteps((steps) => steps.map((item) => (item < 0 ? 0 : item)));
      const timeInterval = setInterval(() => {
        setTimer((new Date().getTime() - startTimerValue.current) / 1000);
      }, 1000);

      return () => {
        clearInterval(timeInterval);
      };
    }
    if (tripStatus == 5) {
      setSteps((steps) => Array(steps.length).fill(20));
    }
  }, [tripStatus]);

  const startTrip = () => {
    setLoading(true);
    api
      .updateTripStatus("", {
        tripId: tripid,
        tripStatus: 2,
      })
      .then((res) => {
        setSteps((steps) => Array(steps.length).fill(0));
        setTripStatus(res.tripStatus || 3);
        startTimerValue.current = new Date().getTime();
        updateLocalTransferStatus(null,3);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const endTrip = ({ delayReason, notes }: any) => {
    setLoading(true);
    return new Promise((resolve, rej) => {
      api
        .updateTripStatus("", {
          tripId: tripid,
          tripStatus: 5,
          //"reasonForDelayId": delayReason || null,
          //"reasonForDelayNote": notes || null
        })
        .then((res) => {
          setSteps((steps) => Array(steps.length).fill(20));
          history.replace("/transferSchedule");         
          setTripStatus(5);
          resolve("");
          setLoading(false);
        })
        .catch((err) => {
          rej(err);
          setLoading(false);
        });
    });
  };

  const endTransfer = ({ delayReason, notes }: any) => {
    setLoading(true);
    setButtonDisable(true);
    return new Promise((resolve, rej) => {
      api
        .updateTransferStatus("", {
          tripId: tripid,
          transferId: currentTransferID.current,
          transferStatus: 4,
          reasonForDelayId: delayReason || null,
          reasonForDelayNote: notes || null,
        })
        .then((res) => {
          if(res?.hasError){
            setErrorMessage(res?.message)
          }
          else{
            resolve("");
          }
          setButtonDisable(false);
          updateLocalTransferStatus(currentTransferID.current, 4);
          setLoading(false);
        })
        .catch((err) => {
          setButtonDisable(false);
          setLoading(false);
          rej(err);
          
        });
    });
  };

  const updateTransferStatus = (transferId: string, transferStatus: number) => {
    setLoading(true);
    return api.updateTransferStatus("", {
      tripId: tripid,
      transferId: transferId,
      transferStatus: transferStatus,
    }).then((res) => {
      updateLocalTransferStatus(transferId,transferStatus);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
    });
  };

  const updateLocalTransferStatus = (transferId: string | null, transferStatus: number) => {
    const updatedTransfers = [...transfers];
    if(transferId == null){
      updatedTransfers.forEach(t => {t.status=transferStatus});
    }
    else{
      const updatedIndex = updatedTransfers.findIndex(t => t.transferId == transferId);
      updatedTransfers[updatedIndex].status = transferStatus;
    }
    setTransfers(updatedTransfers);
  };

  const abortTransfer = (transferId: string, reasonForAbortId: string, reasonForAbortNote: string) => {
    setLoading(true);
    return new Promise(async (res, rej) => {
      await api.updateTransferStatus("", {
        tripId: tripid,
        transferId: transferId,
        transferStatus: 6,
        reasonForAbortId: reasonForAbortId,
        reasonForAbortNote: reasonForAbortNote,
      });
      if (transfers.length == 1) {
        await endTrip({ delayReason: null, notes: null });
      }
      getTripDetails();
      res("");
      closeInfoDialog();
      setLoading(false);
    });
  };

  const retreatTransfer = async (transferId: string, popState: any) => {
    setLoading(true);
    await api.retreatTransfer(`transferId=${transferId}`);
    popState[1](false);
    getTripDetails();
    closeInfoDialog();
    if (transfers.length == 1) {
      await endTrip({ delayReason: null, notes: null });
    }
    setLoading(false);
  };

  if (page == 1) return <ChooseReason endTransfer={endTransfer} setPage={setPage} totalTransfers={transfers.length} endTrip={endTrip} loading={loading} setLoading={setLoading}
  setButtonDisable = {setButtonDisable} buttonDisable = {buttonDisable} errorMessage={errorMessage} setErrorMessage={setErrorMessage}/>;

  if (isLoading)
    return (
      <div className={classes.loadingState}>
        <CircularProgress color="primary" size={50} />
      </div>
    );

  const tripStatusText = () => {
    switch (tripStatus) {
      case 2:
      case 3:
        return `Trip In Progress ${secondsFormat(timer)}`;
      case 5:
        return "Trip Ended";
      case 6:
        return "Trip Aborted";
      case 7:
        return "Picking Up";
      case 8:
        return "En Route To Destination";
      case 9:
        return "Dropping Off";
      default:
        return "";
    }
  };

  const showEndTrip = transfers === null || transfers.length === 0 || !steps.some((s) => s !== 4);

  const submitpcr = async () =>{
    localStorage.setItem("PatientDB",format(new Date(),"dd-MM-yyyy HH:mm:ss"));
    try {
      const res = await api.getEditBookingPCR(`BookingId=${transferLoadingData.bookingId}&TransferId=${transferLoadingData.transferId}`).then((result: any) => {
        if (!result.data.errorRaised) {
          result = result.data.model;
          let  db = localStorage.getItem("PatientDB");
          localStorage.setItem("Patientidentification",JSON.stringify(result));
          localStorage.setItem("PCRCareGivers",JSON.stringify(result.pcrCareGivers));
           history.push("/patientCareRecord/edit/" + db);
        }
    }).catch((error) => {
        
    })
    } catch (err) {
      setLoading(false);
    }
    
  }
    return (
    <MuiThemeProvider theme={themeDark}>
      <div style={{}}>
          {loading ? <CreateLoadingLine /> : null}
      </div>
      <div style={loading ? {pointerEvents: "none"} : {}}>
      <Paper
        style={{
          height: "100vh",
          overflowY: "scroll",
          paddingBottom: 100,
          borderRadius: 0,
        }}
      >
        <div className={classes.container}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "30px 10px" }}>
            <Typography variant="body1" component="div" className={classes.typoBold}>
              {new Date().toString().substr(16, 5)}
            </Typography>
            {tripStatus == 1 && <YellowBox title="Start Trip" onClick={startTrip} />}
            {showEndTrip && <YellowBox title="End Trip" onClick={endTrip} />}

            {!showEndTrip && tripStatus != 1 && (
              <Typography variant="body1" component="div" className={classes.typoLight}>
                {tripStatusText()}
              </Typography>
            )}

            <CloseIcon style={{ cursor: "pointer" }} onClick={() => history.push("/transferSchedule")} />
          </div>
          {transfers.map((item: ISchedule, index: number) =>
            isFullTableWidth ? (
              <TransferWidget
                tripStatus={tripStatus}
                key={item.transferId}
                data={item}
                moreInfoClick={() => {
                  setCurrentTransfer(index);
                  setTrigger((prevState) => !prevState);
                  setInfoDialogOpen(true);
                }}
                step={steps[index]}
                setWaitTimeTransferStatus = {setWaitTimeTransferStatus}
                setWaitTimeClick={setWaitTimeClick}
                setShowWaitingTimeModal={() => {
                  setShowWaitingTimeModal(true);
                  setWaitingTimeModalTransferId(item.transferId);
                  localStorage.setItem("transferId",item.transferId)
                  setWaitTimeClick(true);
                }}
                updateStep={(num: number) => updateStep(num, index)}
              />
            ) : (
              <TransferWidgetForTablets
                tripStatus={tripStatus}
                key={item.transferId}
                data={item}
                moreInfoClick={() => {
                  setCurrentTransfer(index);
                  setTrigger((prevState) => !prevState);
                  setInfoDialogOpen(true);
                }}
                step={steps[index]}
                setWaitTimeTransferStatus = {setWaitTimeTransferStatus}
                setWaitTimeClick={setWaitTimeClick}
                setShowWaitingTimeModal={() => {
                  setShowWaitingTimeModal(true);
                  setWaitingTimeModalTransferId(item.transferId);
                  localStorage.setItem("transferId",item.transferId)
                  setWaitTimeClick(true);
                }}
                updateStep={(num: number) => updateStep(num, index)}
              />
            )
          )}
        </div>
      </Paper></div>
      <Dialog fullScreen open={infoDialogOpen} onClose={closeInfoDialog} TransitionComponent={Transition}>
        <Popup popState={popState} abortTransfer={abortTransfer} transferId={transfers[currentTransfer]?.transferId} />
        <RetreatPopup popState={retreatPopup} transferId={transfers[currentTransfer]?.transferId} retreatTransfer={retreatTransfer} />
        <div style={{ display: "flex", padding: 20, flexDirection: "column" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {enableRecordPCR &&                   
              <Button
                className={classes.buttonRoot}
                onClick={() => submitpcr()}
                style={{ marginLeft: 15 }}
              >
                Record PCR
              </Button>
          }
            <Button style={{ height: 48, marginRight: 10 }}>
              <Typography variant="body1" component="div" className={classes.typoBoldSmall} onClick={() => popState[1](true)}>
                Abort Transfer
              </Typography>
            </Button>
            <Button style={{ height: 48, backgroundColor: "#f4b827", marginRight: 10 }} onClick={() => retreatPopup[1](true)}>
              <Typography variant="body1" component="div" className={classes.typoBoldSmall} style={{ color: "#333333" }}>
                Retreat Transfer
              </Typography>
            </Button>
            <Button style={{ height: 48, width: 92, minWidth: 0, padding: 0, margin: 0 }}>
              <CloseIcon onClick={closeInfoDialog} />
            </Button>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "80%" }}>
              <TransferDetailsComponent data={transfers[currentTransfer]} theme="dark" />
            </div>
          </div>
        </div>
      </Dialog>

      {showWaitingTimeModal && (
        <WaitingTimeModal
          transferId={waitingTimeModalTransferId || ""}
          tripId={tripid}
          WaitTimeTransferStatus={WaitTimeTransferStatus}
          onClose={({ reload = false }) => {
            setShowWaitingTimeModal(false);
            setWaitTimeClick(false);
            localStorage.removeItem("reasonForWaitTimeId");
            localStorage.removeItem("name");
            localStorage.removeItem("transferId");
            localStorage.removeItem("ShowWaitModel");
            if (reload) {
              getTripDetails();
            }
          }}
          setWaitTimeClick = {setWaitTimeClick}
          WaitTimeClick = {WaitTimeClick}
        />
      )}
    </MuiThemeProvider>
  );
}

export default React.memo(TransferTrip);
